import React, { Dispatch } from 'react';
import { SocialProfileFilterGroupView, SocialProfileFilterGroupViewProps } from './SocialProfileFilterGroup.view';
import { TimeslotFilterAction } from '../../../models/calendar';
import { GenericProfileType, Network, SocialOAuthProvider } from '../../../models/graphql';

export type SocialProfileFilterGroupControllerProps = Omit<SocialProfileFilterGroupViewProps, 'setSelectedFilter'> & {
  dispatchFilters: Dispatch<TimeslotFilterAction>;
};

export type ProfileType = {
  id: string;
  connected: boolean;
  provider: SocialOAuthProvider | null;
  network: Network;
  genericProfile?: GenericProfileType;
  photoUrl: string;
  displayName: string;
  onboardingContent: boolean;
};

export const SocialProfileFilterGroupController = (props: SocialProfileFilterGroupControllerProps): JSX.Element => {
  const setSelectedFilter = (id: string) => {
    if (props.isMobile) {
      props.dispatchFilters({ type: 'mobileProfiles', payload: id || null });
    } else {
      props.dispatchFilters({ type: 'profiles', payload: id });
    }
  };

  const viewProps: SocialProfileFilterGroupViewProps = {
    ...props,
    setSelectedFilter
  };

  return <SocialProfileFilterGroupView {...viewProps} />;
};
